import './tokens.css';
import './themes/lcd-casio.css';
import './themes/lcd-blueprint.css';
import './themes/crt-amber.css';
import './themes/mono-phosphor.css';

export type ThemeName =
  | 'lcd-casio'
  | 'lcd-blueprint'
  | 'crt-amber'
  | 'mono-phosphor';

export const themeOrder: ThemeName[] = [
  'lcd-casio',
  'lcd-blueprint',
  'crt-amber',
  'mono-phosphor',
];

export const themeLabels: Record<ThemeName, string> = {
  'lcd-casio': 'LCD-CASIO',
  'lcd-blueprint': 'LCD-BLUEPRINT',
  'crt-amber': 'CRT-AMBER',
  'mono-phosphor': 'PHOSPHOR',
};

export function nextTheme(current: ThemeName): ThemeName {
  const idx = themeOrder.indexOf(current);
  return themeOrder[(idx + 1) % themeOrder.length];
}

const STORAGE_KEY = 'sdt-theme';
const listeners = new Set<() => void>();

export function setTheme(name: ThemeName): void {
  document.documentElement.setAttribute('data-theme', name);
  try {
    localStorage.setItem(STORAGE_KEY, name);
  } catch {
    /* ignore */
  }
  for (const fn of listeners) fn();
}

export function getTheme(): ThemeName {
  const attr = document.documentElement.getAttribute('data-theme');
  return (attr as ThemeName) ?? 'mono-phosphor';
}

export function initTheme(): ThemeName {
  let name: ThemeName = 'mono-phosphor';
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && themeOrder.includes(stored as ThemeName)) {
      name = stored as ThemeName;
    }
  } catch {
    /* ignore */
  }
  setTheme(name);
  return name;
}

export function onThemeChange(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

export function token(name: string, fallback = '#ffffff'): string {
  const v = getComputedStyle(document.documentElement)
    .getPropertyValue(`--${name}`)
    .trim();
  return v || fallback;
}

export function tokenNumber(name: string, fallback = 0): number {
  const v = token(name, '');
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : fallback;
}
